import React, { useEffect, useState } from "react";
import "../../assets/styles/tenantReport.scss";
import PrimaryHeader from "../../components/common/primaryHeader";
import Tenant from "./Tenant";
import { TabView, TabPanel } from "primereact/tabview";
import TenantReportDashBoard from "./TenantReportDashBoard";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { exportCSV, exportExcel, exportPdf } from "../../utils/exportUtils";
import { convertToSearchField, generateColumnMetadata } from "../../utils/utils";
import { commonPostApi } from "../../utils/apiService";

export default function TenantReportList() {
  const [searchText, setSearchText] = useState(1);
  const [activeTab, setActiveTab] = useState("paid");
  const [values, setValues] = useState([]);
  const [columns, setColumns] = useState([]);
  const [dataGridShow, setDataGridShow] = useState(false);
  const [dataGridSelectOption, setDataGirdSelectOption] = useState(1);
  const searchFields = ["patient_name", "patient_code", "surgery_type", "total_amount", "paid_amount", "balance_due"];
  const [dateRange, setDateRange] = useState();
  const [navigator, setNavigator] = useState({
    page: 1,
    rows: 10,
    sortBy: "patient_name",
    sortDir: "ASC",
  });

  const generatePayload = (date1, date2, selectedOption, dataGrid) => {
    const filterType = {
      1: "today",
      2: "week",
      3: "month",
      4: "custom",
    };
    setDateRange((prev) => ({
      startDate: date1,
      endDate: date2,
      filterType: filterType[selectedOption],
      surgery: prev?.surgery,
      searchValue: searchText,
    }));
  };

  function handleSearchChange(value) {
    const data = convertToSearchField(searchFields, value);
    setSearchText(data);
  }

  useEffect(() => {
    init({
      ...navigator,
      surgery: activeTab,
      searchValue: dateRange?.searchValue,
    });
  }, [dateRange]);

  const init = async (nav) => {
    const payload = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      filterType: dateRange?.filterType,
      page: nav?.page,
      limit: nav?.rows,
      sortFields: [[nav?.sortBy, nav?.sortDir]],
      surgery: nav?.surgery,
      searchValue: nav?.searchValue,
    };

    await commonPostApi(API_ENDPOINTS.TENANT_REPORT, payload)
      .then((data = []) => {
        if (data?.data?.data) {
          const finalData = data?.data?.data;
          const generatedColumns =
            finalData.length > 0
              ? generateColumnMetadata({
                data: finalData,
                arrageArray: [
                  "patient_name",
                  "patient_code",
                  "surgery_type",
                  "total_amount",
                  "paid_amount",
                  "balance_due",
                ],
                alias: {
                  patient_name: "Patient",
                  patient_code: "Patient id",
                  surgery_type: "Surgery Type",
                  total_amount: "Total Amount",
                  paid_amount: "Paid Amount",
                  balance_due: "Balance Due",
                },
              })
              : [];

          setColumns(generatedColumns);
          setValues(finalData);
          setNavigator((prev) => ({
            ...prev,
            totalRecords: data?.data?.total || 0,
          }));
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className=" Tenant__report">
      <TenantReportDashBoard />
      <div className="mt-4 tenant">
        <div className="p-3 border-bottom-primary bg-white tenant-report-header">
          <PrimaryHeader
            isCalenderEnabled={true}
            isDownloadButton={true}
            exportCSV={() => exportCSV(values, columns, "Tenant_Report")}
            exportExcel={() => exportExcel(values, columns, "Tenant_Report")}
            exportPdf={() => exportPdf(values, columns, "Tenant_Report")}
            isSearchEnabled={true}
            placeholder={"Search Patients"}
            searchHeaderLable={"Treatments"}
            onChange={handleSearchChange}
            show={dataGridShow}
            onDateRangeChange={(date1, date2, selectedOption = 1) => {
              generatePayload(date1, date2, selectedOption, "dataGrid");
            }}
            setShow={setDataGridShow}
            selectOption={dataGridSelectOption}
            setSelectOption={setDataGirdSelectOption}
          />
        </div>
        <div className="Logistics__table-container">
          <div className="tab-view-sec">
            <TabView
              activeIndex={activeTab === "paid" ? 0 : 1}
              onTabChange={(e) => {
                const selected = e.index === 0 ? "paid" : "free";
                setActiveTab(selected);
                setDateRange((prev) => ({
                  ...prev,
                  surgery: selected,
                }));
              }}
            >
              <TabPanel header="Paid Surgeries">
                <Tenant
                  dateRange={{
                    ...dateRange,
                    surgery: "paid",
                    searchValue: searchText,
                  }}
                  api={API_ENDPOINTS.TENANT_REPORT}
                  search={searchText}
                  columns={columns}
                  values={values}
                />
              </TabPanel>
              <TabPanel header="Free Surgeries">
                <Tenant
                  dateRange={{
                    ...dateRange,
                    surgery: "free",
                    searchValue: searchText,
                  }}
                  api={API_ENDPOINTS.TENANT_REPORT}
                  search={searchText}
                  columns={columns}
                  values={values}
                />
              </TabPanel>
            </TabView>
          </div>
        </div>
      </div>
    </div>
  );
}
